import React, { Component, createRef } from "react";
import ContactBlockNew from "../components/ContactSection/ContactBlockNew";
import Modal from "react-bootstrap/Modal";
import { Footer } from "../components/sections";
import BaseHeader from "../components/baseHeader";
import { tags } from "../components/casesPortfolio/Cases";
import { RequestSection } from "../components/sections";
const getDate = (lang, key) => {
  const cases = window?.cases[lang];
  const currentData = cases.find((item) => item.id === key);
  return currentData;
};

export const scrollToBlock = (id, height) => {
  const tag = document.getElementById(id);
  if (tag) {
    window.scrollTo({
      top: tag.offsetTop - height,
      behavior: "smooth",
    });
  }
};

class CaseSection extends Component {
  titleRef = createRef();
  footerRef = createRef();
  mainTitleRef = createRef();
  taskRef = createRef();
  implementationRef = createRef();
  difficultiesRef = createRef();
  resultRef = createRef();
  sidebarRef = createRef();
  reviewRef = createRef();
  technologiesRef = createRef();
  headerRef = createRef();
  state = {
    data: {},
    img: [],
    ndaImg: [],
    showText: false,
    blockImg: [],
    blockTwo: [],
    currentTagURL: null,
    sidebarStickyOn: "",
    heightBack: 0,
    heightHeaderCase: 0,
    heightHeaderMain: 0,
    nameCase: "",
    win: window.innerWidth,
    isShow: true,
  };
  componentDidMount() {
    const str = window.location.pathname;
    const sl = str.split("/").slice(0, 4);
    const keyCase = sl[3];
    this.setState({
      data: getDate(this.props.lang, keyCase),
      nameCase: keyCase,
    });
    window.addEventListener("scroll", this.stickSidebar);

    setTimeout(() => {
      this.setState({
        heightBack: this.titleRef?.current?.clientHeight,
        heightHeaderCase:
          this.headerRef?.current?.clientHeight +
          this.mainTitleRef?.current?.clientHeight,
        sidebarHeader: this.sidebarRef?.current?.clientHeight,
        currentTagURL: tags.find((tag) => tag.text === this.state.data?.tag),
      });
      window.scrollTo(0, 0);
      this.setState({ isShow: false });
    }, 500);
    window.addEventListener("resize", this.updateDimensions);
  }
  updateDimensions = () => {
    this.setState({ win: window.innerWidth });
  };
  updateHeightHeaderMain = (height) => {
    this.setState({ heightHeaderMain: height });
  };
  stickSidebar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      if (windowHeight <= 900) {
        this.setState({
          sidebarStickyOn: "",
        });
      } else {
        this.setState({
          navbarStickyOn: "",
        });
      }

      if (
        windowHeight >= this.state.heightHeaderCase &&
        this.state.heightHeaderCase
      ) {
        this.setState({
          sidebarStickyOn: "is-sticky ",
        });
      } else {
        this.setState({
          sidebarStickyOn: "",
        });
      }

      if (
        this.footerRef.current?.getBoundingClientRect().top <
        this.state.sidebarHeader + this.state.heightHeaderMain
      ) {
        this.setState({
          navbarStickyOn: "is-static",
        });
      } else {
        this.setState({
          navbarStickyOn: "",
        });
      }
    }
  };

  render() {
    const lang = this.props.lang || "en";
    const page = this.props.page;

    return (
      <>
        {this.state.isShow === true && (
          <div className="pre">
            <img
              className="preloader__image_animate"
              src="/img/ITWEBFOX WHITE_TXT2FIX_NEW.svg"
              alt=""
            />
          </div>
        )}
        <BaseHeader
          lang={lang}
          page={page}
          setHeightHeader={this.updateHeightHeaderMain}
        />
        <div className="case-page">
          <section
            ref={this.headerRef}
            id="header-case"
            className="section bg-inherit overflow-hidden "
          >
            <div
              style={{
                backgroundSize: `100%  ${
                  this.state.win > 768
                    ? this.state.heightBack +
                      (this.state.data?.imgLogo ? 300 : 300) +
                      "px"
                    : "300px"
                }`,
              }}
              className="shapes-container bg-header"
            ></div>
            <div className="container">
              <div className="header-case-wrap h-100 mt-5">
                <div className="case-item">
                  <div className="case-item_img ">
                    <img
                      src={this.state.data?.imgHeading}
                      alt="Кроссплатформенное мобильное приложение для медитаций"
                    />
                  </div>
                  <div className="case-item_desc">
                    <div className="case-item_desc_logo">
                      {this.state.data?.imgLogo && (
                        <div className="case-item_logo">
                          <img src={this.state.data?.imgLogo} alt="alt" />
                        </div>
                      )}
                      <div className="case-item_app">
                        {this.state.data?.logoText}
                      </div>
                    </div>

                    <div
                      ref={this.titleRef}
                      className="case-item_title"
                      dangerouslySetInnerHTML={{
                        __html: this.state.data?.description,
                      }}
                    ></div>
                    <div className="case-item_text">
                      <div className="row">
                        <div className="col-sm-12">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.data?.blockClient,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="case-section">
              <div className="container">
                <h1 className="case_main-title" ref={this.mainTitleRef}>
                  {this.state.data?.h1}
                </h1>
                <div className="case-section_body">
                  <div className="setup_left-column">
                    <div
                      ref={this.sidebarRef}
                      className={`setup-sidebar  ${this.state.sidebarStickyOn} ${this.state.navbarStickyOn} `}
                    >
                      <div className="h4">Содержание</div>
                      <ul className="setup-sidebar_menu">
                        <li>
                          <a
                            href="#block-0"
                            className={`anchor ${
                              this.taskRef.current?.getBoundingClientRect()
                                .top <= 80 &&
                              this.taskRef.current?.getBoundingClientRect()
                                .bottom > 80
                                ? "active"
                                : ""
                            } `}
                          >
                            Задача
                          </a>
                        </li>
                        <li>
                          <a
                            href="#block-1"
                            className={`anchor ${
                              this.implementationRef.current?.getBoundingClientRect()
                                .top <= 80 &&
                              this.implementationRef.current?.getBoundingClientRect()
                                .bottom > 80
                                ? "active"
                                : ""
                            } `}
                          >
                            Реализация
                          </a>
                        </li>
                        <li>
                          <a
                            href="#block-2"
                            className={`anchor ${
                              this.difficultiesRef.current?.getBoundingClientRect()
                                .top <= 80 &&
                              this.difficultiesRef.current?.getBoundingClientRect()
                                .bottom > 80
                                ? "active"
                                : ""
                            } `}
                          >
                            Сложности
                          </a>
                        </li>

                        <li>
                          <a
                            href="#block-4"
                            className={`anchor ${
                              this.resultRef.current?.getBoundingClientRect()
                                .top <= 80 &&
                              this.resultRef.current?.getBoundingClientRect()
                                .bottom > 80
                                ? "active"
                                : ""
                            } `}
                          >
                            Результат
                          </a>
                        </li>
                        <li>
                          <a
                            href="#tech-section"
                            className={`anchor ${
                              this.technologiesRef.current?.getBoundingClientRect()
                                .top <= 80 &&
                              this.technologiesRef.current?.getBoundingClientRect()
                                .bottom > 80
                                ? "active"
                                : ""
                            } `}
                          >
                            Технологии
                          </a>
                        </li>
                      </ul>
                      <div className="h4">Теги по кейсу</div>
                      <ul className="setup-sidebar_tags tag-ul">
                        <li className="item-tag">
                          <a
                            href={`/portfolio/ru?tag=${this.state.currentTagURL?.url}`}
                          >
                            {this.state.data?.tag}
                          </a>
                        </li>
                        {this.state.data?.tagsCase?.map((item, index) => {
                          return (
                            <li key={index} className="item-tag">
                              <a href={`/portfolio/ru?tagcase=${item.url}`}>
                                {item.name}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className="setup_right-column">
                    <div ref={this.taskRef} className="setup_item-box section">
                      <span id="block-0" />
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.state.data?.blockTask,
                        }}
                      />
                      <div className="setup_discuss-box">
                        <div className="h4">
                          Столкнулись с аналогичной задачей? <br />
                          <span className="medium-text">Поможем решить.</span>
                        </div>
                        <div
                          onClick={() => scrollToBlock("contacts", this.state.heightHeaderMain)}
                          data-toggle="modal"
                          className="main-btn js_discuss-btn btn btn-block"
                        >
                          Связаться
                        </div>
                      </div>
                    </div>
                    <div
                      ref={this.implementationRef}
                      className="setup_item-box section"
                    >
                      <span id="block-1" />
                      <h3>{this.state.data?.hImplementationt}</h3>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.state.data?.blockImplementation,
                        }}
                      />
                      {this.state.data.imgList?.length > 0 && (
                        <div className="row case-img_row">
                          {this.state.data.imgList?.map((img, index) => {
                            return (
                              <div key={index} className="col-sm-4">
                                <img alt="alt" src={img} />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <div
                      ref={this.difficultiesRef}
                      className="setup_item-box section"
                    >
                      <span id="block-2" />
                      <h3>{this.state.data?.hDifficultiest}</h3>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.state.data?.blockDifficulties,
                        }}
                      />
                      {this.state.data.blockManedger && (
                        <div className="comment-project_item">
                          <div className="comment-project_img">
                            <img alt="alt" src={this.state.data.imgManedger} />
                          </div>
                          <div className="comment-project_desc">
                            <div className="h4">Комментарий о проекте</div>
                            <span className="comment-project_name">
                              {this.state.data.blockManedgerName}
                            </span>
                            <p>
                              <em
                                dangerouslySetInnerHTML={{
                                  __html: this.state.data.blockManedger,
                                }}
                              />
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    <div
                      ref={this.resultRef}
                      className="setup_item-box section"
                    >
                      <span id="block-4" />
                      <h3>{this.state.data.hResult}</h3>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.state.data?.blockResult,
                        }}
                      />
                      {this.state.data.blockReview && (
                        <div className="setup_item-box section">
                          <span id="block-3" />
                          <div className="review-item">
                            <span className="quotes">“</span>
                            <span className="review-item_header">
                              {this.state.data?.imgLogo && (
                                <img alt="alt" src={this.state.data?.imgLogo} />
                              )}
                            </span>
                            <div className="review-item_body">
                              <div className="review-item_mod-img">
                                <img
                                  alt="alt"
                                  src={this.state.data.imgReview}
                                />
                              </div>
                              <div className="review-item_desc">
                                <span className="review-item_title">
                                  {this.state.data.blockReviewName}
                                </span>
                                <span className="review-item_position">
                                  {this.state.data.blockReviewJob}
                                </span>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.data?.blockReview,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      ref={this.technologiesRef}
                      className="setup_item-box section"
                    >
                      <span id="tech-section" />
                      <h3>{this.state.data?.hTechnologies}</h3>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="technology-item">
                            <span className="technology-item_icon">
                              <img src="/img/backend-case.svg" alt="Бэкэнд" />
                            </span>
                            <div className="technology-item_desc">
                              <span className="technology-item_title">
                                Бэкэнд
                              </span>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    this.state.data?.blockTechnologiesBackend,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="technology-item">
                            <span className="technology-item_icon">
                              <img
                                src="/img/methodology.svg"
                                alt="Методология"
                              />
                            </span>
                            <div className="technology-item_desc">
                              <span className="technology-item_title">
                                Методология
                              </span>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    this.state.data
                                      ?.blockTechnologiesMethodology,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="technology-item">
                            <span className="technology-item_icon">
                              <img src="/img/frontend.svg" alt="Фронтенд" />
                            </span>
                            <div className="technology-item_desc">
                              <span className="technology-item_title">
                                Фронтенд
                              </span>

                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    this.state.data?.blockTechnologiesFrontend,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div ref={this.footerRef}></div>
        <ContactBlockNew lang={lang} page={page} />
        <RequestSection lang={lang} page={page} />
        <Footer lang={lang} />
        <Modal show={this.state.isOpen} onHide={() => this.closeModal()}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.data.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body></Modal.Body>
        </Modal>
      </>
    );
  }
}

export default CaseSection;
